import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Table } from 'reactstrap';
import PropTypes from 'prop-types';
import { TrashIcon } from 'assets/icons';
import { TableStyles } from './styles';

const TableUnifiedLinks = ({ data, onRemove, onClearAll }) => {
  const { t: translate } = useTranslation();

  if (!data || data.length === 0) {
    return null;
  }

  return (
    <TableStyles>
      <Table>
        <thead>
          <tr>
            <th colSpan={2} style={{ width: '4rem' }}>
              <div className="d-flex gap-2 align-items-center">
                {translate('URLs to be unified')}
              </div>
            </th>
            <th className="text-end" style={{ width: '120px' }}>
              <div className="d-flex gap-2 align-items-center justify-content-end">
                <Button className="btn-clean-all" onClick={onClearAll}>
                  {translate('Clean all')}
                </Button>
              </div>
            </th>
          </tr>
        </thead>
        <tbody>
          {data &&
            data.length > 0 &&
            data.map((url, index) => (
              <tr key={url + index}>
                <td style={{ width: '4rem', verticalAlign: 'middle' }}>
                  <div className="d-flex align-items-center justify-content-center">
                    {`${index > 8 ? '' : '0'}${index + 1}`}
                  </div>
                </td>
                <td
                  style={{
                    verticalAlign: 'middle',
                  }}
                >
                  <div className="d-flex align-items-center">
                    <span>{url}</span>
                  </div>
                </td>
                <td className="text-end" style={{ width: '2.5rem', verticalAlign: 'middle' }}>
                  <div className="d-flex justify-content-end">
                    <Button className="btn-trash" onClick={() => onRemove(url)}>
                      <TrashIcon />
                    </Button>
                  </div>
                </td>
              </tr>
            ))}
        </tbody>
      </Table>
    </TableStyles>
  );
};

TableUnifiedLinks.propTypes = {
  data: PropTypes.array.isRequired,
  onRemove: PropTypes.func.isRequired,
  onClearAll: PropTypes.func.isRequired,
};

export default TableUnifiedLinks;
